<template>
  <v-container fluid ma-0 pa-0 px-4 pb-4 id="bucketedit-main">
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  {{bucketTitle}}
                </h2>
              </template>
                <span>{{bucketTitle}}</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header d-inline-block">{{pluralizedCaseTypeName}} - <span class="font-weight-bold">{{bucketCount}}</span></h4>
            <h4 class="pt-1 pl-3 sub-header d-inline-block">New in last 24hrs - <span class="font-weight-bold">{{bucketDayCount}}</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical v-if="hasServiceLevel"></v-divider>
          <v-flex shrink fill-height class="sla" v-if="hasServiceLevel"><!-- if one of SLA's in jeopardy or breach add class 'jeopardy' or 'breach' here -->
            <v-tooltip  color="secondary" bottom>
              <v-btn
                icon
                flat
                slot="activator"
                @click="SLADialog = true"
                >
                <v-icon color="secondary" size="20">
                  notifications_active
                </v-icon>
              </v-btn>
              <span>2 Service Levels</span>
            </v-tooltip>
          </v-flex>
          <v-dialog v-model="SLADialog" width="400">
            <v-card class="pa-4">
              <v-card-title class="ma-0 mb-2 pa-0">
                <h2>
                  Service Level:<br>
                  <strong>{{serviceLevelName}}</strong>
                </h2>
              </v-card-title>
              <v-flex xs12>
                <v-flex xs12 d-block class="tertiary--text mb-1">
                  <h4 class="font-weight-bold">
                    <v-icon
                      size="21" color="tertiary" class="ma-0 mr-2"
                      style="vertical-align:top">
                      notifications_active
                    </v-icon>
                    Jeopardy {{jeopardyTime}} after {{caseTypeName}} created.
                  </h4>
                </v-flex>
                <v-flex xs12 d-block class="error--text">
                  <h4 class="font-weight-bold">
                    <v-icon
                      size="21" color="error" class="ma-0 mr-2"
                      style="vertical-align:top">
                      notifications_active
                    </v-icon>
                    Breach {{breachTime}} after {{caseTypeName}} created.
                  </h4>
                </v-flex>
              </v-flex>
              <v-card-actions class="ma-0 mt-3 pa-0">
                <v-btn @click="SLADialog = false" color="error">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider vertical v-if="hasPermission('Create')" ></v-divider>
          <v-flex shrink fill-height class="action" v-if="hasPermission('Create')">
            <v-tooltip left color="secondary">
                  <v-btn
                icon
                flat
                slot="activator"
                 @click="createCase()"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create new {{caseTypeName}}</span>
                </v-tooltip>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex shrink fill-height class="vert-dots">
        <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
          <v-btn
            flat
            slot="activator"
            icon
            class="ma-0 pa-0"
            dark
            color="secondary"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile v-if="!isBookmarked" @click="createBookmark()">
              <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this bucket
              </v-list-tile>
              <v-list-tile v-if="isBookmarked" @click="removeBookmark()">
              <v-icon class="mr-2" color="secondary">bookmark</v-icon>Remove bookmark
             </v-list-tile>
               <!-- <v-list-tile @click="editOwnerDialog = true">
                <v-icon class="mr-2" color="secondary">person</v-icon>Edit Bucket Owner
              </v-list-tile> -->
              <v-list-tile @click="refresh()">
                <v-icon class="mr-2" color="secondary">refresh</v-icon>Refresh Cases
              </v-list-tile>
              <!-- <v-list-tile @click="showShareDialog = true">
                <v-icon class="mr-2" color="secondary">share</v-icon>Share
              </v-list-tile> -->
               <v-list-tile v-if="hasPermission('Export')" @click="exportBucket()">
                <v-icon class="mr-2" color="secondary">vertical_align_bottom</v-icon>Export
              </v-list-tile>
              <v-list-tile @click="setupBucket()">
                <v-icon class="mr-2" color="secondary">edit</v-icon>Configure Bucket
              </v-list-tile>
              <v-divider class="pb-1 mt-2"></v-divider>
              <v-list-tile @click="taskToggled = !taskToggled; selectMode = false">
                <v-icon class="mr-2" color="secondary">done_all</v-icon> {{ taskToggled ? 'Hide tasks' : 'Run a task' }}
              </v-list-tile>
              <v-list-tile v-if="hasPermission('Delete')" @click="toggleSelectMode()">
                <v-icon class="mr-2" color="secondary">delete</v-icon> {{ selectMode ? 'Hide selection' : 'Select cases to delete' }}
              </v-list-tile>
              <v-list-tile @click="searchToggled = !searchToggled">
                <v-icon class="mr-2" color="secondary">search</v-icon>{{ searchToggled ? 'Hide Search' : 'Search' }}
              </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      </v-layout>
      </div>
      <v-container pa-0 pt-4 ma-0 fluid>
    <v-layout v-if="showViewOptions" wrap style="position:relative; min-height:26px;">
      <div class="view-toggles" style="position:absolute;top:-10px; right:-8px;">
        <v-tooltip top color="secondary">
          <v-btn
            slot="activator"
            class="ma-0"
            v-bind:class="{ activeView: tableView }"
            icon
            @click="boardView = false; mapView = false; tableView = true"
          >
            <v-icon color="secondary">view_headline</v-icon>
          </v-btn>
          <span>Table View</span>
        </v-tooltip>
        <!-- <v-tooltip top color="secondary">
          <v-btn
            @click="boardView = true; mapView = false; tableView= false"
            slot="activator"
            class="ma-0"
            v-bind:class="{ activeView: boardView }"
            icon
          >
            <v-icon color="secondary">view_column</v-icon>
          </v-btn>
          <span>Board View</span>
        </v-tooltip> -->
        <v-tooltip top color="secondary">
          <v-btn
            @click="boardView = false; mapView = true; tableView = false"
            slot="activator"
            class="ma-0"
            v-bind:class="{ activeView: mapView }"
            icon
          >
            <v-icon color="secondary">place</v-icon>
          </v-btn>
          <span>Map View</span>
        </v-tooltip>
      </div>
    </v-layout>
     <BucketShareDialog
        :showShareDialog="showShareDialog"
        :available-users="availableUsers"
        :available-teams="availableTeams"
        :participating-users="participatingUsers"
        :participating-teams="participatingTeams"
        v-on:share-dialog-closed="showShareDialog = false">
      </BucketShareDialog>
    <!--<v-layout wrap class="mb-3">
      <v-flex>
        <div class="d-inline-block">
          <v-btn
            style="min-width: 20px;"
            id="btn_refresh"
            class="ml-0 mr-2 mb-2 mt-0"
            @click="refresh()"
            color="secondary">
            <v-icon>refresh</v-icon>
          </v-btn>
        </div>
        <BucketShareDialog
          :available-users="availableUsers"
          :available-teams="availableTeams"
          :participating-users="participatingUsers"
          :participating-teams="participatingTeams">
        </BucketShareDialog>

        <div class="d-inline-block">
          <v-btn
            style="min-width: 20px;"
            id="btn_export"
            class="ml-0 mr-2 mb-2 mt-0"
            @click="exportBucket()"
            color="secondary">
            <v-icon>refresh</v-icon>
            <div class="hidden-xs-only">&emsp;Export</div>
          </v-btn>
        </div>

        <div class="d-inline-block">
          <v-btn
            style="min-width: 20px;"
            id="btn_refresh"
            class="ml-0 mr-2 mb-2 mt-0"
            @click="setupBucket()"
            color="secondary">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
        <div class="d-inline-block">
          <v-btn
            style="min-width: 20px;"
            id="btn_search"
            class="ml-0 mr-2 mb-2 mt-0"
            v-on:click="toggleSearch()"
            color="secondary">
            <v-icon>search</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>-->
    <v-container v-if="isGraphVisible">
      <Loading :isLoading="isChartLoading">
        <v-layout row>
          <v-spacer></v-spacer>
          <v-layout v-for="(stat, i) in bucket.contents.statistics.kpis" :key="i" row>
            <v-spacer></v-spacer>
            <v-chip label disabled text-color="primary">
              {{stat.key}}:&emsp;
              <b>{{stat.value}}</b>
            </v-chip>
            <v-spacer></v-spacer>
          </v-layout>
          <v-spacer></v-spacer>
        </v-layout>
        <v-flex>
          <v-img src="https://vega.github.io/vega/examples/img/bar-chart.png"></v-img>
        </v-flex>
      </Loading>
    </v-container>
    <v-layout style="background:white" class="rounded-3 elevation-3" row wrap>
    <v-flex xs12>
    <v-slide-y-transition>
      <v-container fluid ma-0 pa-0 v-if="selectMode">
        <v-layout row wrap align-center class="px-4 py-3">
          <v-flex grow>
            <h3 class="ma-0">{{ selectionCount }} selected</h3>
            <p class="ma-0">Delete the ticked cases, or every case matching the current list.</p>
          </v-flex>
          <v-btn class="mr-2" color="error" :disabled="selectionCount === 0" @click="openDeleteDialog(false)">Delete selected</v-btn>
          <v-btn color="error" outline :disabled="!matchingCount" @click="openDeleteDialog(true)">Delete all {{ matchingCount }} matching</v-btn>
        </v-layout>
      </v-container>
    </v-slide-y-transition>
    <v-dialog v-model="deleteDialog" max-width="520">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Delete {{ deleteTargetCount }} cases?</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <p>Each case is deleted on its own. Permissions and delete scripts still apply. This cannot be undone.</p>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn color="error" :loading="deleting" @click="confirmDelete()">Yes, delete {{ deleteTargetCount }} cases</v-btn>
          <v-btn color="secondary" @click="deleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-slide-y-transition>
      <v-container fluid ma-0 pa-0 v-if="taskToggled">
        <RunTasks
          :case-type-id="caseTypeId"
          :selections="bucketSelections">
        </RunTasks>
      </v-container>
    </v-slide-y-transition>
    <v-slide-y-transition>
      <v-container ma-0 pa-0 v-if="searchToggled">
      <v-flex px-4 mt-3>
       <v-card-title class="ma-0 mb-2 pa-0">
        <h3>Search bucket</h3>
      </v-card-title>
        <v-layout row wrap class="mt-3 mb-0">
          <v-flex xs12 sm6 md4 :class="{'mr-0 ': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}">
            <v-text-field
              box clearable ref="searchInput"
              color="secondary" clear-icon="cancel" id="buckets-search-text"
              label="Search for..." placeholder="Type your search here"
              v-model="searchTermModel"
              @keydown.enter="searchTerm = searchTermModel"
              class="remove-top-right-border-radius">
              <template slot="append">
                <v-icon>search</v-icon>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 style="margin-left:-0px;" class="pl-0 pt-0">
            <v-select
              box color="secondary" label="within..."
              :items="searchableFields"
              v-model="selectedField"
              placeholder="All Fields"
              clear-icon="cancel"
              append-icon="keyboard_arrow_down"
              class="remove-top-left-border-radius"
            ></v-select>
          </v-flex>
        </v-layout>
        </v-flex>
         <v-divider class="mb-0"></v-divider>
      </v-container>
    </v-slide-y-transition>
    <v-slide-y-transition>
    <BucketKPIs
      v-if="bucket.displayGroupByPanel"
      v-on:stat-selected="filterKpi"
      v-on:stat-cleared="clearKpi">
    </BucketKPIs><!-- Stats shown only if user has chosen a group by field in the bucket config -->
    </v-slide-y-transition>
    </v-flex>
    <v-autocomplete
      v-if="mapView && locationFields.length > 1"
      box dense
      class="px-4 pt-4"
      :items="locationFields"
      label="Location Fields"
      v-model="mapViewField"
      no-data-text="No results"
      append-icon="keyboard_arrow_down">
    </v-autocomplete>
    <bucket-map
      v-if="mapView"
      :mapField="mapViewField"
      :searchTerm="mapViewSearchTerm"
      :searchField="mapViewSearchField">
    </bucket-map>
    <bucket-table
      v-if="tableView"
      ref="bucketTable"
      :dataProvider="localDataProvider"
      :dataSearcher="localDataSearcher"
      :searchTerm="searchTerm"
      :selectedField="selectedField"
      :taskToggled="taskToggled || selectMode"
      :current-filter="currentFilter"
      :filter-toggle="filterToggle"
      v-on:selections-update="setBucketSelections"
    ></bucket-table>
    </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Helpers from "@/helpers.js"
import Loading from "@/components/shared/Loading.vue"
import DataProvider from "@/components/buckets/bucket-providers/BucketDataProviderGeneral.js"
import DataSearcher from "@/components/buckets/bucket-providers/BucketDataProviderSearch.js"
import BucketTable from "@/components/buckets/BucketTable.vue"
import BucketMap from '@/components/buckets/bucket-elements/BucketMap'
import BucketKPIs from "@/components/buckets/bucket-elements/BucketKPIs.vue"
import BucketShareDialog from "@/components/buckets/bucket-elements/BucketShareDialog.vue"
import RunTasks from "@/components/buckets/bucket-elements/RunTasks"
import { mapState } from "vuex"
import Vue from "vue"

export default {
  components: {
    Loading,
    BucketTable,
    BucketShareDialog,
    RunTasks,
    BucketMap,
    BucketKPIs
  },
  created() {
    // Create local references to avoid mutating props
    this.localDataProvider = Object.assign({}, this.dataProvider, { store: this.$store })
    this.localDataSearcher = Object.assign({}, this.dataSearcher, { store: this.$store })
  },
  mounted() {
    this.$store.dispatch("setPageTitle", this.bucketTitle)
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeRouteLeave(to, from, next) {
    Vue.store.dispatch("unsubscribeFromBucketPresence")
    next()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  props: {
    dataProvider: {
      type: Object,
      default: function() {
        return DataProvider
      }
    },
    dataSearcher: {
      type: Object,
      default: function() {
        return DataSearcher
      }
    }
  },
  data: () => ({
    currentFilter: {
      active: false,
      field: "all_fields",
      term: "",
      itemCount: 0,
      page: 1,
      prevPage: 1,
      currentPage: 1
    },
    filterToggle: false,
    taskToggled: false,
    selectMode: false,
    deleteDialog: false,
    deleteAllMatching: false,
    deleting: false,
    SLADialog: "",
    searchToggled: false,
    isGraphVisible: false,
    isChartLoading: false,
    editOwnerDialog: false,
    showRunTasksDialog: false,
    showShareDialog: false,
    searchTermModel: "", // Prevent searching while typing
    searchTerm: "",
    selectedField: "all_fields",
    mapViewSearchTerm: "",
    mapViewSearchField: "all_fields",
    tableView: true,
    boardView: false,
    mapView: false,
    bucketSelections: [],
    selectedMapViewField: ""
  }),
  computed: {
    ...mapState({
      bucketLoading: state => state.buckets.current.loading,
      bucket: state => state.buckets.current.bucket,
      schema: state => state.buckets.current.schema,
      cbroute: state => state.cbroute,
      isBookmarked: state => state.buckets.current.bookmarked,
      currentUser: state => state.currentUser,
      bookmarks: state => state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems : [],
      permissions: state => state.ui.grantedPermissions,
      caseTypeName: state =>
        state &&
        state.buckets &&
        state.buckets.current.caseType
          ? Helpers.caseTypeName(state.buckets.current.caseType)
          : "",
      caseTypeCode: state =>
        state &&
        state.buckets &&
        state.buckets.current.caseType &&
        state.buckets.current.caseType.code
          ? state.buckets.current.caseType.code
          : undefined,
      pluralizedCaseTypeName: state =>
        state &&
        state.buckets &&
        state.buckets.current.caseType
          ? Helpers.pluralize(Helpers.caseTypeName(state.buckets.current.caseType))
          : "",
      ownerDisplayName: state =>
        state &&
        state.buckets &&
        state.buckets.current.bucket &&
        state.buckets.current.bucket.owner &&
        state.buckets.current.bucket.owner.displayName
          ? state.buckets.current.bucket.owner.displayName
          : "",
      availableUsers: state =>
        state && state.users && state.users.all ? state.users.all : [],
      availableTeams: state =>
        state && state.teams && state.teams.all ? state.teams.all : [],
      participatingUsers: state => {
        if (
          state &&
          state.buckets &&
          state.buckets.current.bucket &&
          state.buckets.current.bucket.participants
        ) {
          return state.buckets.current.bucket.participants.filter(
            p => p.__typename === "User"
          )
        } else {
          return []
        }
      },
      participatingTeams: state => {
        if (
          state &&
          state.buckets &&
          state.buckets.current.bucket &&
          state.buckets.current.bucket.participants
        ) {
          return state.buckets.current.bucket.participants.filter(
            p => p.__typename === "Team"
          )
        } else {
          return []
        }
      },
      searchableFields() {
        const fields = []
        let index = 0
        fields.push({ text: "All Fields", value: "all_fields", index: index })
        this.schema.forEach(function(header) {
          if (header.type === "string" || header.type === "number") {
            index++
            fields.push({
              text: Helpers.capitalizeRemoveUnderscores(header.name),
              value: header.text,
              index: index
            })
          }
        })
        return fields
      },
      bucketTitle: state =>
        state && state.buckets && state.buckets.current.bucket
          ? state.buckets.current.bucket.name
          : "Loading...",
      bucketDayCount: state =>
        state &&
        state.buckets &&
        state.buckets.current.bucket &&
        state.buckets.current.bucket.contents &&
        state.buckets.current.bucket.contents.statistics
          ? state.buckets.current.bucket.contents.statistics.totalCreated24hrs
          : "",
      bucketCount: state =>
        state &&
        state.buckets &&
        state.buckets.current.bucket &&
        state.buckets.current.bucket.contents &&
        state.buckets.current.bucket.contents.statistics
          ? state.buckets.current.bucket.contents.statistics.total
          : ""
    }),
    caseTypeId() {
      return parseInt(this.$route.params.case_type_id)
    },
    selectionCount() {
      return this.bucketSelections ? this.bucketSelections.length : 0
    },
    matchingCount() {
      const count = parseInt(this.bucketCount, 10)
      return isNaN(count) ? 0 : count
    },
    deleteTargetCount() {
      return this.deleteAllMatching ? this.matchingCount : this.selectionCount
    },
    mapViewField: {
      get() {
        if (this.locationFields && this.selectedMapViewField === "") {
          return this.locationFields[0]
        }
        return this.selectedMapViewField
      },
      set(field) {
        this.selectedMapViewField = field
      }
    },
    hasServiceLevel() {
      if (this.bucket && this.bucket.serviceLevel) {
        return this.bucket.serviceLevel.enabled
      }
      return false
    },
    serviceLevelName() {
      if (this.hasServiceLevel && this.bucket && this.bucket.serviceLevel.name) {
        return this.bucket.serviceLevel.name
      }
      return "Untitled Service Level"
    },
    jeopardyTime() {
      const sla = this.bucket && this.bucket.serviceLevel ? this.bucket.serviceLevel : null
      if (this.hasServiceLevel && sla) {
        return this.formatSlaDuration(sla.inJeopardyThreshold)
      }
      return ""
    },
    breachTime() {
      const sla = this.bucket && this.bucket.serviceLevel ? this.bucket.serviceLevel : null
      if (this.hasServiceLevel && sla) {
        return this.formatSlaDuration(sla.inBreachThreshold)
      }
      return ""
    },
    showViewOptions() {
      return this.locationFields.length > 0
    },
    locationFields() {
      const caseType = Helpers.getCaseTypeByCode(this.$store.state, this.caseTypeCode)
      const locationFields = []
      if (caseType) {
        for (const fieldset of caseType.currentSchema.fieldsets) {
          for (const field of fieldset.fields) {
            if (["location", "address", "entity"].includes(field.type)) {
              locationFields.push(Helpers.capitalizeRemoveUnderscores(field.name))
            }
          }
        }
      }
      return locationFields
    }
  },
  watch: {
    searchTermModel() {
      // Reset search results when clear is selected..
      if (!this.searchTermModel) {
        this.searchTerm = this.searchTermModel
      }
    },
    bucketTitle() {
      this.$store.dispatch("setPageTitle", this.bucketTitle)  
    }
  },
  methods: {
    formatSlaDuration(threshold) {
      if (!threshold) {
        return ""
      }
      const day = threshold.days || 0
      const hr = threshold.hours || 0
      const min = threshold.minutes || 0
      let time = ""
      if (day > 0) {
        time += ((day === 1) ? day + " day " : day + " days ")
      }
      if (hr > 0) {
        time += ((hr === 1) ? hr + " hour " : hr + " hours ")
      }
      if (min > 0) {
        time += ((min === 1) ? min + " minute " : min + " minutes ")
      }
      if (!time) {
        time = "0 minutes "
      }
      return time
    },
    async filterKpi(data) {
      this.mapViewSearchTerm = data.kpi.key
      this.mapViewSearchField = Helpers.formatSnakeCase(data.field)
      this.currentFilter.field = Helpers.formatSnakeCase(data.field)
      this.currentFilter.term = data.kpi.key
      this.currentFilter.itemCount = data.kpi.value
      this.currentFilter.active = true
      this.currentFilter.currentPage = 1
      this.currentFilter.prevPage = 1
      this.filterToggle = !this.filterToggle
    },
    clearKpi() {
      this.mapViewSearchTerm = ""
      this.mapViewSearchField = "all_fields"
      this.currentFilter.field = ""
      this.currentFilter.term = ""
      this.currentFilter.itemCount = 0
      this.currentFilter.active = false
      this.currentFilter.page = 1
      this.filterToggle = !this.filterToggle
    },
    hasPermission(permission) {
      if (this.currentUser.isAccountAdmin) { return true }
      return Helpers.hasPermission(this.permissions, permission, this.caseTypeCode)
    },
    async createBookmark() {
      const result = await this.$store.dispatch("createBookmark", { route: this.$route.fullPath, linkText: this.bucketTitle })
      if (result) { this.$store.commit('setBucketBookmarked', true) }
    },
    async removeBookmark() {
      let id
      this.bookmarks.forEach(bookmark => {
        if (bookmark.route === this.$route.fullPath) { id = bookmark.id }
      })
      if (id > 0) {
        const result = await this.$store.dispatch("deleteBookmark", { id })
        if (result) { this.$store.commit('setBucketBookmarked', false) }
      } else {
        this.$store.commit("displayFlashMessage", { message: "ID not found, cannot delete..", severity: "error" })
      }
    },
    ownerSelected(selection) {
      if (selection && selection.length > 1) {
        const typeChar = selection.substring(0, 1)
        const index = parseInt(selection.substring(1), 10)
        if (typeChar === "t") {
          const owner = this.availableTeams.find(t => t.id === index)
          this.$store.dispatch("updateBucketOwner", {
            bucket: this.bucket,
            type: "team",
            owner
          })
        } else {
          const owner = this.availableUsers.find(u => u.id === index)
          this.$store.dispatch("updateBucketOwner", {
            bucket: this.bucket,
            type: "user",
            owner
          })
        }
      }
    },
    exportBucket() {
      this.$store.dispatch("exportBucket", this.bucket.id)
    },
    setupBucket() {
      this.$store.dispatch("checkBucketBookmark", this.$route.fullPath, this.bookmarks)
      this.$router.push({
        name: "BucketEdit",
        params: { bucket_id: this.bucket.id }
      })
    },
    async toggleSearch() {
      this.searchToggled = !this.searchToggled
      await Vue.nextTick()
      if (this.searchToggled && this.$refs.searchInput) {
        this.$refs.searchInput.focus()
      }
    },
    refresh() {
      this.$store.dispatch("checkBucketBookmark", this.$route.fullPath)
      this.$refs.bucketTable.refreshData()
    },
    createCase() {
      this.$store.dispatch("clearNewCaseRelations")
      this.$router.push({
        name: "CaseNew",
        params: { case_type_id: this.caseTypeId }
      })
    },
    setBucketSelections(newSelections) {
      this.bucketSelections = newSelections
    },
    toggleSelectMode() {
      this.selectMode = !this.selectMode
      if (this.selectMode) {
        this.taskToggled = false
      }
      this.bucketSelections = []
    },
    openDeleteDialog(allMatching) {
      this.deleteAllMatching = allMatching
      if (this.deleteTargetCount < 1) return
      this.deleteDialog = true
    },
    async confirmDelete() {
      this.deleting = true
      let result
      if (this.deleteAllMatching) {
        const payload = {
          bucketId: parseInt(this.bucket.id, 10),
          confirmedCount: this.matchingCount
        }
        if (this.searchTerm) {
          payload.searchField = this.selectedField || "all_fields"
          payload.searchTerm = this.searchTerm
        } else if (this.currentFilter.active && this.currentFilter.term) {
          payload.searchField = this.currentFilter.field
          payload.searchTerm = this.currentFilter.term
        }
        result = await this.$store.dispatch("deleteBucketCases", payload)
      } else {
        result = await this.$store.dispatch("deleteCases", this.bucketSelections)
      }
      this.deleting = false
      this.deleteDialog = false
      if (result) {
        this.bucketSelections = []
        this.selectMode = false
        this.refresh()
      }
    },
    onResize() {
      const max = Math.floor(window.innerWidth / 100) + 2
      if (this.viewerMax !== max) {
        if (max >= this.viewerMin) {
          this.viewerMax = max
        } else {
          this.viewerMax = this.viewerMin
        }
      }
    }
  }
}
</script>

<style>
.view-toggles .v-btn {
  opacity: 0.54 !important;
  transition: all 0.3s;
}

.view-toggles .v-btn:hover {
  opacity: 1 !important;
  transition: all 0.3s;
}

.view-toggles .activeView.v-btn {
  opacity: 1 !important;
}

</style>
